export const iconFontAwesomeArrowsArrowsUpDown = (
	<i className="fa-solid fa-arrows-up-down"></i>
);
